module.exports = __webpack_public_path__ + "img/used_icon.ce547542.png";